export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_53-5f8559f6736971052cd922032de1caa6.jpg";